import { niTrackEvent } from '@xsite-ui/common.event-tracker';

var NUMBER_OF_DAYS_TO_SAVE_HIDE_COOKIE_BAR = 57;
var DAYS_IN_MILLISECONDS = 864e5;
var TIME_TO_HIDE_COOKIE_BANNER_IN_MILLISECONDS = NUMBER_OF_DAYS_TO_SAVE_HIDE_COOKIE_BAR * DAYS_IN_MILLISECONDS;
var initCookiePolicyScript = function initCookiePolicyScript() {
  var cookieBanner = document.querySelector('.cookies-policy');

  if (!cookieBanner || !shouldShowCookieBanner(cookieBanner)) {
    return;
  }

  showCookieBanner(cookieBanner);
  niTrackEvent({
    category: 'CookiePolicy',
    action: 'seen',
    optLabel: 'cookie banner show',
    optValue: 1,
    optNonInteraction: true
  });
  var closeBtn = document.querySelector('#cookies-policy-close_wrapper');

  if (!closeBtn) {
    return;
  }

  closeBtn.addEventListener('click', function closeBanner() {
    var _cookieBanner$parentE;

    (_cookieBanner$parentE = cookieBanner.parentElement) === null || _cookieBanner$parentE === void 0 ? void 0 : _cookieBanner$parentE.removeChild(cookieBanner);
    addLocalStorage();
  });
};

var addLocalStorage = function addLocalStorage() {
  var expires = new Date();
  expires.setMilliseconds(expires.getMilliseconds() + TIME_TO_HIDE_COOKIE_BANNER_IN_MILLISECONDS);
  var cookie = {
    value: 'cookiebanner',
    expire_date: expires.toUTCString()
  };
  localStorage.setItem('cookiepolicy', JSON.stringify(cookie));
};

var shouldShowCookieBanner = function shouldShowCookieBanner(cookieBanner) {
  var localDateStorage = localStorage.getItem('cookiepolicy');

  if (localDateStorage) {
    var _cookieBanner$parentE2;

    (_cookieBanner$parentE2 = cookieBanner.parentElement) === null || _cookieBanner$parentE2 === void 0 ? void 0 : _cookieBanner$parentE2.removeChild(cookieBanner);
    return Date.now() > new Date(JSON.parse(localDateStorage).expire_date).valueOf();
  }

  return true;
};

var showCookieBanner = function showCookieBanner(element) {
  element.classList.remove('hidden_banner');
};

export { initCookiePolicyScript };
